import { createContext, useContext } from 'react'

/**
 * Pure-React form contexts, kept free of any `@tanstack/react-form` import.
 *
 * __root.tsx mounts FormOptionalLabelProvider eagerly, so it must reach these
 * without dragging in form-core. The rest of form/shared.tsx (which DOES depend
 * on @tanstack/react-form) re-exports these for the form-field components.
 */
const FormReadOnlyContext = createContext(false)
export const FormReadOnlyProvider = FormReadOnlyContext.Provider
export const useFormReadOnly = () => useContext(FormReadOnlyContext)

const FormOptionalLabelContext = createContext('Optional')
export const FormOptionalLabelProvider = FormOptionalLabelContext.Provider
export const useFormOptionalLabel = () => useContext(FormOptionalLabelContext)
